import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber, getSortIndicator } from '../../../utils/helpers';
import useSortedData from '../hooks/useSortedData';
import usePagination from '../hooks/usePagination';
import '../components/ContestInfo.css';
import './ParticipantsTable.css';
import './Tables.css';

const ParticipantsTablePokerRegistering = ({ contest }) => {
  const playersPerPage = 20;

  // Sort by chipCount within sportSpecificData
  const { sortedData: sortedPlayers, requestSort, sortConfig } = useSortedData(contest.players, 'sportSpecificData.chipCount', 'descending');

  // Use the usePagination hook for pagination
  const { currentItems: currentPlayers, nextPage, prevPage, currentPage } = usePagination(sortedPlayers, playersPerPage);

  return (
    <div className="participants-table-container">
      <div className="participants-table-header">
        {/* Using specific header text for Poker */}
        <span className="participants-table-header-text">PLAYERS ({contest.players.length})</span> 
      </div>
      <table className="participants-table-registering">
        <thead>
          <tr>
            <th onClick={() => requestSort('name')}>
              NAME {getSortIndicator(sortConfig, 'name')}
            </th>
            {/* Sort by nested chipCount */}
            <th onClick={() => requestSort('sportSpecificData.chipCount')}>
              CHIPS {getSortIndicator(sortConfig, 'sportSpecificData.chipCount')}
            </th>
            {/* Sort by nested icmValue */}
            <th onClick={() => requestSort('sportSpecificData.icmValue')}>
              ICM {getSortIndicator(sortConfig, 'sportSpecificData.icmValue')}
            </th>
            {contest.format !== 'H2H' && contest.draftType !== 'Snake' && (
              <th onClick={() => requestSort('salary')}>
                SALARY {getSortIndicator(sortConfig, 'salary')}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {currentPlayers.map((player, index) => (
            <tr key={index}>
              <td>{player.name}</td>
              {/* Access chipCount from sportSpecificData */}
              <td>{typeof player.sportSpecificData?.chipCount === 'number' ? formatNumber(player.sportSpecificData.chipCount) : 'N/A'}</td>
              {/* Access icmValue from sportSpecificData */}
              <td>
                {typeof player.sportSpecificData?.icmValue === 'number' ? `$${formatNumber(player.sportSpecificData.icmValue, 2)}` : 'N/A'}
              </td>
              {contest.format !== 'H2H' && contest.draftType !== 'Snake' && <td>${formatNumber(player.salary)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination-controls">
        <button onClick={prevPage} disabled={currentPage === 1}>
          Back
        </button>
        {/* Added page number display */}
        <span>Page {currentPage}</span> 
        <button onClick={nextPage} disabled={currentPage * playersPerPage >= sortedPlayers.length}>
          Next
        </button>
      </div>
    </div>
  );
};

ParticipantsTablePokerRegistering.propTypes = {
  contest: PropTypes.shape({
    players: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      salary: PropTypes.number,
      // Add sportSpecificData shape for Poker
      sportSpecificData: PropTypes.shape({
        chipCount: PropTypes.number, 
        icmValue: PropTypes.number, 
      })
    })).isRequired,
    format: PropTypes.string.isRequired,
    draftType: PropTypes.string
  }).isRequired
};

export default ParticipantsTablePokerRegistering;
